import { createModel } from '@rematch/core';
import type { RootModel } from './models';
import { ProviderDto } from '@ampsec/platform-client';

const providerMap = createModel<RootModel>()({
    state: {
        ...({} as Record<string, ProviderDto>),
    },
    reducers: {
        setProviderMap(_state, payload) {
            return { ...payload };
        },
    },
});

export default providerMap;
